import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { verifySignupAccount } from "../../redux/actions/User";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import AuthLayout from "./Layout";

const VerifyAccount = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { verifiedAccount, verifyingAccount } = useSelector((state) => state.User);

  useEffect(() => {
    dispatch(verifySignupAccount(params.token));
  }, [params.token]);

  return (
    <>

      <AuthLayout>
        <Typography textAlign="center" maxWidth="460px" variant="h3" sx={{
            color: "#016AFE"
        }}>VCPlayer</Typography>
        <Typography textAlign="center" maxWidth="460px" variant="h4" sx={{
            color: "#313031"
        }}>SIGNAGE</Typography>

        {verifyingAccount && <Typography sx={{ color: "#313031" }} textAlign="center"> {t("views.verifyAccount.verifying")}</Typography>}

        {verifiedAccount && (
          <>
            <Typography sx={{ color: "#313031" }} textAlign="center"> {t("views.verifyAccount.success")}</Typography>
            <Box>
                <Button variant="contained" type="submit" onClick={() => navigate('/')} fullWidth sx={{
                    "&.Mui-disabled": {
                        background: "#d3d3d3ff",
                        color: "#919191ff"
                    }
                }}>{t("views.login.login")}</Button>
            </Box>
          </>
        )}
      </AuthLayout>
    </>
  );
};

export default VerifyAccount;
